import { useState } from 'react';
import { validateSignupIncome } from 'helpers/signup.helpers';
import { formatIncome } from "helpers/money.helper";

function useIncomeInput(income) {
  const initIncome = trimIncome(income);
  const initError = getError(initIncome);
  const initDisplay = getFormattedIncome(initIncome);

  const [annualIncome, setAnnualIncome] = useState({
    value: initIncome,
    error: initError,
    displayValue: initDisplay,
  });

  function getError(input) {
    return validateSignupIncome(input);
  }

  function trimIncome(input) {
    return input
      .toString()
      .trim()
      .replace(/([$,])/g, '');
  }

  function getFormattedIncome(input) {
    const trimmedValue = trimIncome(input);
    const formattedValue = input === '$' ? '' : formatIncome(trimmedValue);

    return formattedValue;
  }

  return {
    annualIncome,
    update(value) {
      const trimmedIncome = trimIncome(value);
      const error = getError(trimmedIncome);
      const formattedIncome = getFormattedIncome(value);

      setAnnualIncome({
        value: trimmedIncome,
        error: error,
        displayValue: formattedIncome,
      });

      return;
    },
    trimIncome(value) {
      return trimIncome(value);
    },
  };
}

export default useIncomeInput;
